// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2eb12ab7","455":"a4b9189f","977":"2ec00532"}[chunkId] + ".chunk.js";
};